// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Modal-cls1___94e306e7f65184f16ac{/*!*/}.Modal-cls2___f041fba9dd644ac2b58{background:rgba(0,0,0,.6);display:grid;left:0;place-items:center;position:fixed;top:0;width:100vw;z-index:10;overflow-y:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Modal-cls1___94e306e7f65184f16ac",
	"cls2": "Modal-cls2___f041fba9dd644ac2b58 Modal-cls1___94e306e7f65184f16ac"
};
export default ___CSS_LOADER_EXPORT___;
